<section class="modal-section">
  <div class="row">
    <div class="col-lg-4 p-0">
      <div class="text-wrap p-4 py-5 text-center d-flex align-items-center order-md-last mx-1">
        <div class="text w-100">
          <img src="assets/images/logo.png" class="white_logo" alt="" />
          <p class="set-fnt mb-4">Are you an Incubator ?</p>
          <button class="btn btn-white" routerLink="/register" routerLinkActive="active" (click)="modalClose()">
            Register Here
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-4 p-0">
      <div class="text-wrap p-4 py-5 text-center d-flex align-items-center order-md-last mx-1">
        <div class="text w-100">
          <img src="assets/images/logo.png" class="white_logo" alt="" />
          <p class="set-fnt mb-4">Apply For Pre-Incubation</p>
          <!-- <button class="btn btn-white" routerLink="/pre-incubator-register" routerLinkActive="active"
            (click)="modalClose()" [disabled]="isRegistrationClosedPre"
            [ngClass]="{ 'disabled-btn': isRegistrationClosedPre }">
            {{ isRegistrationClosedPre ? "Registration Closed" : "Register Here" }}
          </button> -->
          <button class="btn btn-white" routerLink="/pre-incubator-register" routerLinkActive="active"
            (click)="modalClose()">
            Register Here
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-4 p-0">
      <div class="text-wrap p-4 py-5 text-center d-flex align-items-center order-md-last mx-1">
        <div class="text w-100">
          <img src="assets/images/logo.png" class="white_logo" alt="" />
          <p class="set-fnt mb-4">Apply For CoE</p>
          <button class="btn btn-white" routerLink="/coe-register" routerLinkActive="active" (click)="modalClose()"
            [disabled]="isRegistrationClosedCoE">
            {{
            isRegistrationClosedCoE ? "Registration Closed" : "Register Here"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>